<template>
    <Component
        :is="typography.tag || 'p'"
        :class="[
            ...classes,
            ...typographyUtilityClasses(typography),
        ]"
    >
        {{ decodeHtmlEntities(text) }}
    </Component>
</template>

<script setup>
import { typographyUtilityClasses } from '@utils/typography';
import decodeHtmlEntities from '../../../js/utils/decode-html-entities';

defineProps({
    text: {
        type: String,
        required: true,
    },
    classes: {
        type: Array,
        required: false,
        default: () => [],
    },
    typography: {
        type: Object,
        required: false,
        default: () => ({
            tag: 'p',
            visual: 'paragraph-regular',
        }),
    },
});
</script>
